<template>
  <div class="gf_notice_banner">
    <div class="gf_notice_banner-inner">
      <div class="gf_notice_banner-inner--close" @click="$emit('close')">
        <i class="icon icon-small-cancel"></i>
      </div>
      <div class="gf_notice_banner-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M3.86484 5.08729C4.02044 5.00686 4.19864 4.9813 4.37057 5.01475C4.54251 5.04821 4.69812 5.13872 4.81221 5.27163L8.76114 9.87859L11.3248 5.39219C11.3929 5.27323 11.4911 5.17436 11.6097 5.10559C11.7283 5.03683 11.8629 5.00062 11.9999 5.00062C12.137 5.00062 12.2716 5.03683 12.3902 5.10559C12.5087 5.17436 12.607 5.27323 12.6751 5.39219L15.2387 9.87859L19.1877 5.27163C19.3016 5.13822 19.4574 5.04726 19.6296 5.01353C19.8017 4.9798 19.9803 5.00528 20.1362 5.08583C20.292 5.16639 20.4161 5.29728 20.4882 5.45725C20.5603 5.61721 20.5762 5.79686 20.5333 5.96699L18.1999 15.3007C18.1577 15.469 18.0604 15.6184 17.9236 15.7251C17.7867 15.8318 17.6181 15.8897 17.4446 15.8895H6.55528C6.38175 15.8897 6.21315 15.8318 6.07629 15.7251C5.93944 15.6184 5.84219 15.469 5.80003 15.3007L3.4666 5.96699C3.42409 5.79703 3.44021 5.61769 3.51235 5.45802C3.58449 5.29836 3.70842 5.16773 3.86406 5.08729H3.86484ZM5.77591 8.78577L7.16197 14.3339H16.8364L18.224 8.78577L15.7008 11.729C15.6196 11.8235 15.5169 11.8972 15.4014 11.9438C15.2858 11.9904 15.1608 12.0085 15.0368 11.9967C14.9127 11.9849 14.7934 11.9435 14.6887 11.8759C14.584 11.8083 14.4971 11.7166 14.4353 11.6084L11.9999 7.34605L9.56384 11.6084C9.50201 11.7166 9.4151 11.8083 9.31042 11.8759C9.20575 11.9435 9.08637 11.9849 8.96234 11.9967C8.83831 12.0085 8.71326 11.9904 8.59771 11.9438C8.48216 11.8972 8.37949 11.8235 8.29835 11.729L5.77591 8.78577ZM5.77747 18.2229C5.77747 18.0166 5.85942 17.8188 6.00529 17.6729C6.15115 17.5271 6.34899 17.4451 6.55528 17.4451H17.4446C17.6509 17.4451 17.8487 17.5271 17.9946 17.6729C18.1405 17.8188 18.2224 18.0166 18.2224 18.2229C18.2224 18.4292 18.1405 18.6271 17.9946 18.7729C17.8487 18.9188 17.6509 19.0007 17.4446 19.0007H6.55528C6.34899 19.0007 6.15115 18.9188 6.00529 18.7729C5.85942 18.6271 5.77747 18.4292 5.77747 18.2229Z" fill="#3C67FF"/>
        </svg>
      </div>
      <div class="gf_notice_banner-content">
        <div class="gf_notice_banner-content--title">
          {{ $t(title) }}
        </div>
        <div class="gf_notice_banner-content--description">
          {{ $t(description) }}
        </div>
        <div class="gf_notice_banner-content--button">
          <button class="btn btn-primary gf_notice_banner-content--offer" @click="$emit('onclick')">{{ $t(submitText) }}</button>
          <a :href="$t(learnMoreUrl)" target="_blank" class="gf_notice_banner-content--learn-more">{{ $t(learnMoreText) }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "NoticeBanner",
  filters: {},
  props: {
    title: {
      type: String,
    },
    description: {
      type: String
    },
    submitText: {
      type: String
    },
    learnMoreText: {
      type: String,
    },
    learnMoreUrl: {
      type: String,
    }
  },
  computed: {

  }
}
</script>
<style lang="scss" scoped>
  .gf_notice_banner {
    box-sizing: border-box;
    padding: 16px;
    background: #D8E1FF;
    min-height: 160px;
    width: 100%;
    margin-bottom: 40px;

    &-inner {
      display: flex;
      gap: 16px;
      position: relative;

      &--close {
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 3px;
        &:hover {
          background-color: rgba(0, 0, 0, 0.1);
        }
      }
    }

    &-content {
      display: flex;
      flex-direction: column;
      color: #212121;

      &--title {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
        letter-spacing: -0.32px;
        margin-bottom: 8px;
      }

      &--description {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        margin-bottom: 12px;
      }

      &--button {
        display: flex;
        gap: 12px;
        align-items: center;
      }

      &--offer {
        width: 110px;
        height: 36px;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
      }

      &--learn-more {
        color: #3C67FF;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
        &:hover {
          color: #0A3BE7;
        }
      }
    }
  }
</style>
